import { enterThemeScope } from '@dashboard/lib/theme';
import useMountEffect from '@dashboard/hooks/useMountEffect';
import useTheme from '@dashboard/hooks/useTheme';

// useTheme() keeps the OS listener alive, so System follows a change made while the app is open.
export function ThemeScope({ children }) {
  useTheme();
  useMountEffect(enterThemeScope);
  return children;
}
